var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8485 9.42718V3.31809C21.8485 1.81809 20.6212 0.59082 19.1212 0.59082H2.75755C1.25755 0.59082 0.0302734 1.81809 0.0302734 3.31809V19.6817C0.0302734 21.1817 1.25755 22.409 2.75755 22.409H19.1212C20.6212 22.409 21.8485 21.1817 21.8485 19.6817V13.5726L26.1439 17.8408C26.5666 18.2772 27.303 17.9635 27.303 17.3635V5.63628C27.303 5.03627 26.5666 4.72264 26.1439 5.159L21.8485 9.42718ZM10.9394 6.04537C12.4394 6.04537 13.6666 7.27264 13.6666 8.77264C13.6666 10.2726 12.4394 11.4999 10.9394 11.4999C9.43936 11.4999 8.21209 10.2726 8.21209 8.77264C8.21209 7.27264 9.43936 6.04537 10.9394 6.04537ZM16.3939 16.9545H5.48482V16.1772C5.48482 15.0726 6.13936 14.0908 7.14846 13.6545C8.30755 13.1499 9.58936 12.8635 10.9394 12.8635C12.2894 12.8635 13.5712 13.1499 14.7303 13.6545C15.7394 14.0908 16.3939 15.0726 16.3939 16.1772V16.9545Z",
    fill: "#a890fe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContent);
export default __webpack_public_path__ + "static/media/ic_content.9552d3673c514de10f4d48e324c4e375.svg";
export { ForwardRef as ReactComponent };